<ng-container *ngIf="customer$ | async as customer">
    <div class="customer-list-entry-container">
        <div class="status">
            <span *ngIf="customer.CustomerStatus !== CustomerStatusEnum.Inaktiv && customer.CustomerStatus !== CustomerStatusEnum.Gesperrt" [matTooltip]="CustomerStatusTypeNames.get(CustomerStatusEnum.Aktiv)" class="aktiv-dot"></span>
            <span *ngIf="customer.CustomerStatus === CustomerStatusEnum.Inaktiv" [matTooltip]="CustomerStatusTypeNames.get(CustomerStatusEnum.Inaktiv)" class="inaktiv-dot"></span>
            <span *ngIf="customer.CustomerStatus === CustomerStatusEnum.Gesperrt" [matTooltip]="CustomerStatusTypeNames.get(CustomerStatusEnum.Gesperrt)" class="gesperrt-dot"></span>
        </div>
        <div class="customer-information">
            <span>{{customer.DisplayName}}</span>
        </div>
    </div>
</ng-container>

